

const APPCONFIG = {
    REACT_APP_LOCALYTICS_APP_KEY_DEV:process.env.REACT_APP_LOCALYTICS_APP_KEY_DEV,
    REACT_APP_LOCALYTICS_APP_KEY_PROD:process.env.REACT_APP_LOCALYTICS_APP_KEY_PROD
};

export { APPCONFIG };
